import { Layout } from '@/components/ui/layout';
import { PrivateAdminRoute } from '@/components/organisms/route/admin';
import { BigQuerySyncPreviewPanel } from '@/components/organisms/bigQuerySyncPreview/BigQuerySyncPreviewPanel';
import { Alert } from '@/components/molecules/alert';
import { useAlert } from '@/hooks/useAlert';

export default function BigQuerySyncPreviewPage() {
  const { alert, showAlert, handleCloseAlert } = useAlert();

  return (
    <PrivateAdminRoute>
      <Layout title="Pré-visualização sync BigQuery">
        <BigQuerySyncPreviewPanel onNotify={showAlert} />
      </Layout>

      <Alert
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        autoHideDuration={5000}
        onClose={handleCloseAlert}
      />
    </PrivateAdminRoute>
  );
}
